import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { AviatorHistoryModule } from '../../../../modules/support/manage-user/gameplay-history/aviator-history';

export const Route = createFileRoute(
  '/dashboard/support/manage-user/aviator-history'
)({
  validateSearch: z.object({
    userId: z.string().optional(),
    type: z.enum(['CREDIT', 'DEBIT']).optional(),
    status: z.enum(['COMPLETED', 'INITIATED']).optional(),
    page: z.number().optional(),
    limit: z.number().optional(),
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <AviatorHistoryModule />;
}
